import { useTranslation } from "@repo/translation";
import { isValidDate, logError } from "@repo/utils";
import { type Locale, format } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";

interface LocalizedTimeProps {
  date?: string | Date;
  timezone?: string;
}

export const LocalizedTime = ({ date, timezone }: LocalizedTimeProps) => {
  const { dateFnsLocale } = useTranslation();
  if (!date) {
    return "-";
  }

  return <>{localizeTime(date, dateFnsLocale, timezone)}</>;
};

export const localizeTime = (
  date: string | Date,
  dateFnsLocale?: Locale,
  timezone?: string
) => {
  if (!date) {
    return "-";
  }

  try {
    const d = date instanceof Date ? date : new Date(date);

    if (!isValidDate(d)) {
      return "-";
    }

    if (timezone) {
      return formatInTimeZone(d, timezone, "p", { locale: dateFnsLocale });
    }
    return format(d, "p", { locale: dateFnsLocale });
  } catch (e) {
    logError(e, [{ tagName: "date", tagValue: date?.toString() }]);
    return "-";
  }
};
